import { getAxiosClient } from "../axios";

export const resetDemoData = async () => {
  const axiosClient = await getAxiosClient();

  return await axiosClient
    .post(`/demodata/reset`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("error", error);
      return Promise.reject(error);
    });
};